import './cruise-finder.scss';

import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { createElementFromHTML, serializeForm } from '../../utilities/js/helper';
import AjaxLoad from '../../utilities/js/ajax-load';
import debounce from 'lodash.debounce';

class CruiseFinder {
    constructor (element) {
        this.$cruiseFinder = element;
        this.$results = this.$cruiseFinder.querySelector('[data-cruise-finder="results"]');
        this.$mainFilter = this.$cruiseFinder.querySelector('[data-cruise-finder="main"]');
        this.$rangeSlider = this.$cruiseFinder.querySelector('[data-cruise-finder="range-slider"]');
        this.$rangeSliderMin = this.$cruiseFinder.querySelector('[data-cruise-finder="range-min"]');
        this.$rangeSliderMax = this.$cruiseFinder.querySelector('[data-cruise-finder="range-max"]');
        this.$form = this.$cruiseFinder.querySelector('[data-cruise-finder="form"]');
        this.$rangeSliderLockedValue = this.$cruiseFinder.querySelector('[data-cruise-finder="range-locked-value"]');
        this.$filterToggle = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-toggle"]');
        this.$filterCheckbox = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-toggle-checkbox"]');
        this.$filterContent = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-content"]');
        this.$filterContentInner = this.$cruiseFinder.querySelector('[data-cruise-finder="filter-content-inner"]');
        this.$$selectFields = this.$cruiseFinder.querySelectorAll('[data-cruise-finder="select-field"]');
        this.$$switchFields = this.$cruiseFinder.querySelectorAll('[data-cruise-finder="switch-field"]');
        this.$$allInputFields = this.$cruiseFinder.querySelectorAll('[data-cruise-finder-input="field"]');
        this.$rcpSelect = this.$cruiseFinder.querySelector('[data-cruise-finder="rcp"]');
        this.$resetAllFilter = this.$cruiseFinder.querySelector('[data-cruise-finder="reset"]');

        this.$routeGroupSelect = this.$form.querySelector('select[name="routeGroup[]"]');
        this.$countiesSelect = this.$form.querySelector('select[name="countries[]"]');
        this.$portsSelect = this.$form.querySelector('select[name="ports[]"]');
        this.$regionsSelect = this.$form.querySelector('select[name="regions[]"]');

        this.$currency = this.$cruiseFinder.querySelector('[data-cruise-finder="currency"]');
        this.$resultsCounter = this.$cruiseFinder.querySelector('[data-cruise-finder-counter]');

        this.rangeSliderMin = parseInt(this.$rangeSliderMin.dataset.rangeValue, 10);
        this.rangeSliderMax = parseInt(this.$rangeSliderMax.dataset.rangeValue, 10);
        this.rangeSliderStart = this.$rangeSliderMin.value;
        this.rangeSliderEnd = this.$rangeSliderMax.value;

        if (this.rangeSliderStart <= 0 && this.rangeSliderEnd <= 0) {
            this.rangeSliderStart = this.rangeSliderMin;
            this.rangeSliderEnd = this.rangeSliderMin;
        }

        this.ajaxURL = this.$form.getAttribute('action');
        this.ajaxActive = false;
        this.lastEmptyItemInGrid = null;
        this.desktopActiveState = false;

        this.$paginationSelect = this.$results.querySelector('select');
    }

    initialize () {
        this.setEvents();

        if (this.$filterToggle && this.$filterCheckbox && this.$filterContentInner) {
            this.checkSizes();
            this.changeA11yLabelsByCheckbox();

            this.$filterCheckbox.onchange = () => {
                this.changeA11yLabelsByCheckbox();

                if (!window.mediaMatch[768].matches) {
                    if (this.$filterCheckbox.checked) {
                        console.log(this.$filterCheckbox.checked);
                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                        disableBodyScroll(this.$filterContentInner);
                    } else {
                        enableBodyScroll(this.$filterContentInner);
                    }
                }

                if (window.mediaMatch[1024].matches) {
                    console.log('??');
                    if (this.$filterCheckbox.checked) {
                        this.desktopActiveState = false;
                    } else {
                        this.desktopActiveState = true;
                    }
                }
            };

            this.$filterToggle.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    this.$filterCheckbox.checked = !this.$filterCheckbox.checked;
                    this.changeA11yLabelsByCheckbox();
                }

                if (event.code === 'Escape') {
                    event.preventDefault();
                    this.$filterCheckbox.checked = false;
                    this.changeA11yLabelsByCheckbox();
                }
            });
        }

        if (this.$rangeSlider) {
            this.initRangeSlider();
        }

        this.checkPosition();
        this.checkIfFilterTypeHasValue();
        this.handleChangeOnInputField();
        this.handleResetAllFilter();
    }

    checkPosition (callback) {
        window.eventScroller.customFunctions.push(() => {
            setTimeout(() => {
                if (window.scrollPosition > 1500 && window.mediaMatch[1024].matches) {
                    this.$filterCheckbox.checked = false;
                    this.changeA11yLabelsByCheckbox();
                    this.$filterCheckbox.onchange = () => {
                        if (this.$filterCheckbox.checked) {
                            window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                            this.desktopActiveState = false;
                        } else {
                            this.desktopActiveState = true;
                        }
                    };
                }

                if (window.scrollPosition < 1500 && window.mediaMatch[1024].matches) {
                    if (this.desktopActiveState === false) {
                        this.$filterCheckbox.checked = true;
                        this.changeA11yLabelsByCheckbox();
                    }
                }
            }, 300);
        });
    }

    checkIfFilterTypeHasValue () {
        this.$$selectFields.forEach($selectField => {
            const selectField = $selectField.querySelector('[data-select]');
            if (selectField) {
                if (!selectField.value) {
                    $selectField.classList.add('has--no-value');
                } else {
                    $selectField.classList.remove('has--no-value');
                }
            }
        });

        this.$$switchFields.forEach($switchField => {
            const switchField = $switchField.querySelector('[data-cruise-finder="switch-field-checkbox"]');
            if (!switchField.checked) {
                $switchField.classList.add('has--no-value');
            } else {
                $switchField.classList.remove('has--no-value');
            }
        });

        this.checkAllInputsToGetTheLastOne();
    }

    checkAllInputsToGetTheLastOne () {
        this.$$allInputFields.forEach($inputField => {
            if (!$inputField.classList.contains('has--no-value')) {
                this.lastEmptyItemInGrid = $inputField;
                $inputField.classList.remove('last--item');
            }
        });

        if (this.lastEmptyItemInGrid !== null) {
            this.lastEmptyItemInGrid.classList.add('last--item');
        }
    }

    initRangeSlider () {
        const rangeSliderFlexLabel = this.$rangeSliderLockedValue.dataset.rangeLabelFlexible;
        const rangeSliderDayLabel = this.$rangeSliderLockedValue.dataset.rangeLabelDays;
        const rangeSliderFromLabel = this.$rangeSliderLockedValue.dataset.rangeLabelFrom;

        const rangeMax = this.rangeSliderMax + 1;
        let minValue;
        let maxValue;

        noUiSlider.create(this.$rangeSlider, {
            start: [this.rangeSliderStart, this.rangeSliderEnd],
            range: {
                min: this.rangeSliderMin,
                max: this.rangeSliderMax + 1
            },
            connect: true,
            step: 1,
            tooltips: {
                to: function (value) {
                    const formatedValue = Math.round(value);
                    if (formatedValue >= rangeMax) {
                        return rangeSliderFlexLabel;
                    } else {
                        return formatedValue + ' ' + rangeSliderDayLabel;
                    }
                }
            }
        });

        const updateRangeSliderInputs = (handle, value) => {
            const formatedValue = Math.round(value);

            if (handle === 0 && this.$rangeSliderMin) {
                this.$rangeSliderMin.value = formatedValue;
                minValue = formatedValue;
            } else if (handle === 1 && this.$rangeSliderMax) {
                this.$rangeSliderMax.value = formatedValue;
                maxValue = formatedValue;

                if (formatedValue >= rangeMax) {
                    this.$rangeSliderMax.value = 365;
                }
            }

            if (minValue === maxValue && maxValue <= rangeMax) {
                this.$rangeSliderLockedValue.innerText = `${rangeSliderFromLabel} ${maxValue} ${rangeSliderDayLabel}`;
            } else if (minValue === maxValue && maxValue >= rangeMax) {
                this.$rangeSliderLockedValue.innerText = rangeSliderFlexLabel;
            } else if (maxValue >= rangeMax) {
                this.$rangeSliderLockedValue.innerText = `${rangeSliderFromLabel} ${minValue} - ${rangeSliderFlexLabel}`;
            } else {
                this.$rangeSliderLockedValue.innerText = `${minValue} - ${maxValue} ${rangeSliderDayLabel}`;
            }
        };

        this.$rangeSlider.noUiSlider.on('update', function (values) {
            values.forEach((value, index) => {
                updateRangeSliderInputs(index, value);
            });
        });

        this.$rangeSlider.noUiSlider.on('end', debounce(() => {
            this.checkBeforeSubmit(0);
        }, 1500), { passive: true });

        window.addEventListener('reset.filter', () => {
            this.$rangeSlider.noUiSlider.setHandle(0, this.rangeSliderStart, true, true);
            this.$rangeSlider.noUiSlider.setHandle(1, this.rangeSliderEnd, true, true);
        });
    }

    setLockedValues ($selectField, $lockedValue) {
        const $$options = $selectField.querySelectorAll('option');
        let selectedLabels = '';

        if ($$options.length > 0) {
            $$options.forEach($option => {
                if ($option.selected) {
                    selectedLabels += ((selectedLabels !== '') ? ', ' : '') + $option.text;
                }
            });
        }
        $lockedValue.innerText = selectedLabels;
    }

    handleChangeOnInputField () {
        this.$$selectFields.forEach($select => {
            const $selectInput = $select.querySelector('[data-select]');
            const $selectLockedValue = $select.querySelector('[data-cruise-finder="select-locked-value"]');

            if ($selectInput) {
                this.setLockedValues($selectInput, $selectLockedValue);

                $selectInput.addEventListener('change', () => {
                    this.setLockedValues($selectInput, $selectLockedValue);
                    this.checkIfFilterTypeHasValue();
                    this.checkBeforeSubmit();
                });
            }

            window.addEventListener('reset.filter', () => {
                if ($selectInput) {
                    $selectInput.selectedIndex = -1;
                    this.setLockedValues($selectInput, $selectLockedValue);
                    this.checkIfFilterTypeHasValue();
                }
            });
        });

        this.$$switchFields.forEach($switch => {
            const $switchCheckbox = $switch.querySelector('[data-cruise-finder="switch-field-checkbox"]');
            const $switchToggle = $switch.querySelector('[data-cruise-finder="switch-field-toggle"]');

            $switchCheckbox.addEventListener('change', () => {
                this.checkBeforeSubmit();
                this.checkIfFilterTypeHasValue();
            });

            $switchToggle.addEventListener('keydown', (event) => {
                if (event.code === 'Space' || event.code === 'Enter') {
                    event.preventDefault();
                    $switchCheckbox.checked = !$switchCheckbox.checked;
                }
            });

            window.addEventListener('reset.filter', () => {
                if ($switchCheckbox) {
                    $switchCheckbox.checked = $switchCheckbox.getAttribute('data-toggle-switch-init-value');
                    this.checkIfFilterTypeHasValue();
                }
            });
        });
    }

    changeA11yLabelsByCheckbox () {
        if (this.$filterCheckbox.checked) {
            this.$filterToggle.setAttribute('aria-expanded', 'true');
            this.$filterToggle.setAttribute('aria-selected', 'true');
            this.$filterContent.setAttribute('aria-hidden', 'false');
            this.$mainFilter.classList.add('is--active');
        } else {
            this.$filterToggle.setAttribute('aria-expanded', 'false');
            this.$filterToggle.setAttribute('aria-selected', 'false');
            this.$filterContent.setAttribute('aria-hidden', 'true');
            this.$mainFilter.classList.remove('is--active');
        }
    }

    setEvents () {
        this.$form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.checkBeforeSubmit(0);

            if (!window.mediaMatch[1024].matches) {
                this.$filterCheckbox.checked = false;
                this.changeA11yLabelsByCheckbox();
            }
        });

        this.$currency.addEventListener('change', (e) => {
            e.preventDefault();
            this.checkBeforeSubmit(0);
        });

        window.onpopstate = (e) => {
            if (e.state === null) {
                location.replace(window.location.href);
            }
        };

        if (this.$paginationSelect && !window.mediaMatch[1024].matches) {
            this.$paginationSelect.addEventListener('change', (e) => {
                window.location.href = e.target.value;
            });
        }
    }

    checkSizes () {
        if (window.mediaMatch[1024].matches) {
            this.$filterCheckbox.checked = true;
            this.changeA11yLabelsByCheckbox();
        }

        window.mediaMatch[1024].addEventListener('change', (match) => {
            if (!match.matches) {
                this.$filterCheckbox.checked = false;
                this.changeA11yLabelsByCheckbox();
            }

            if (match.matches) {
                this.$filterCheckbox.checked = true;
                this.changeA11yLabelsByCheckbox();
                enableBodyScroll(this.$filterContentInner);
            }
        });
    }

    checkMultiSelect () {
        const options = [].slice.call(this.$rcpSelect && this.$rcpSelect.options);
        const resetSelect = ($select) => {
            if ($select) {
                const $options = $select.querySelectorAll('option');

                if ($options.length > 0) {
                    $options.forEach((option) => {
                        option.selected = false;
                    });
                }
            }
        };

        resetSelect(this.$countiesSelect);
        resetSelect(this.$regionsSelect);
        resetSelect(this.$portsSelect);

        const setOption = ($select, option) => {
            const $options = Array.from($select.options);
            const optionToSelect = $options.find(item => item.text === option.text);
            optionToSelect.selected = true;
        };

        options.forEach((option) => {
            if (option.selected) {
                if (option.dataset.cruise === 'regions[]') {
                    setOption(this.$regionsSelect, option);
                }
                if (option.dataset.cruise === 'countries[]') {
                    setOption(this.$countiesSelect, option);
                }
                if (option.dataset.cruise === 'ports[]') {
                    setOption(this.$portsSelect, option);
                }
            }
        });
    }

    checkBeforeSubmit (timer = 0) {
        clearTimeout(this.waitTimer);

        if (this.ajaxActive === false) {
            this.checkMultiSelect();

            this.waitTimer = setTimeout(() => {
                this.$results.appendChild(createElementFromHTML(window.OPTIONS.loader));
                this.sendRequest();
                this.ajaxActive = true;
            }, timer);
        } else {
            console.log('Please wait.....Request is running');
        }
    }

    handleResetAllFilter () {
        const setResetEventAndSubmit = () => {
            const resetAllEvent = new CustomEvent('reset.filter', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$results
                }
            });

            window.dispatchEvent(resetAllEvent);
            this.checkBeforeSubmit(0);
        };

        this.$resetAllFilter.onclick = () => {
            setResetEventAndSubmit();
        };

        this.$resetAllFilter.addEventListener('keydown', (event) => {
            if (event.code === 'Space' || event.code === 'Enter') {
                event.preventDefault();
                setResetEventAndSubmit();
            }
        });
    }

    setHistory () {
        const url = this.$form.dataset.formAction + '?' + serializeForm(this.$form);

        history.pushState(null, null, url);
    }

    sendRequest () {
        const formData = new FormData(this.$form);

        formData.append('currency', this.$currency.value);
        formData.delete('rcp');

        if (this.$$switchFields.length > 0) {
            this.$$switchFields.forEach($switchField => {
                const switchField = $switchField.querySelector('[data-cruise-finder="switch-field-checkbox"]');

                if (!switchField.checked) {
                    formData.append(switchField.getAttribute('name'), '0');
                }
            });
        }

        this.setHistory();

        this.result = new AjaxLoad(this.ajaxURL, {
            requestMethod: 'post',
            requestData: formData,
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);

                if (!this.$filterCheckbox.checked && !window.mediaMatch[768].matches) {
                    enableBodyScroll(this.$filterContentInner);
                }

                this.setResult(results);
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    setResult (results) {
        this.ajaxActive = false;
        const $result = createElementFromHTML(results.html);
        this.$results.innerHTML = '';

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$results.appendChild(item);
            });
        } else {
            this.$results.appendChild($result);
        }

        if (results.count) {
            if (this.$resultsCounter) {
                this.$resultsCounter.firstElementChild.innerText = results.count;
            }
        } else {
            if (this.$resultsCounter) {
                this.$resultsCounter.firstElementChild.innerText = '0';
            }
        }

        const contentUpdateEvent = new CustomEvent('content.loaded', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$results
            }
        });

        window.dispatchEvent(contentUpdateEvent);

        window.bookmark.initialize(this.$results);
    }
}

export { CruiseFinder };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $cruiseFinder = $context.querySelector('[data-cruise-finder="root"]');

        if ($cruiseFinder) {
            const cruiseFinder = new CruiseFinder($cruiseFinder);
            cruiseFinder.initialize();
        }
    }
});
